function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RuleSetting',
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    }
  },
  props: {
    tabName: {
      type: String,
      default: ''
    },
    conf: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      grid1: {
        xl: 8,
        lg: 5,
        md: 24,
        sm: 24,
        xs: 24
      },
      grid2: {
        xl: 8,
        lg: 14,
        md: 24,
        sm: 24,
        xs: 24
      },
      checkList: [],
      title: '',
      type: 0,
      examineFrom: {
        abnormal: 0,
        auto: 0,
        edit: [1, 2],
        recall: 0
      },
      rules: {},
      showAll: true,
      checkedName: '',
      userList: [],
      dataList: []
    };
  },
  created: function created() {
    if (_typeof(this.conf) === 'object' && this.conf !== null) {
      if (Number(this.conf.abnormal) > 0) this.conf.abnormal = 1;
      this.conf.edit = this.conf.edit.map(Number);
      Number(this.conf.recall) > 0 ? this.conf.recall = true : this.conf.recall = false;
      this.conf.auto = Number(this.conf.auto);
      if (this.conf.ab_card) {
        this.conf.ab_card.value = this.conf.ab_card.id;
        this.dataList = [this.conf.ab_card];
      }
      if (this.conf.ab_card) this.checkedName = this.conf.ab_card.name;
      Object.assign(this.examineFrom, this.conf);
    }
  },
  methods: {
    // 选择成员完成回调
    getSelectList: function getSelectList(data) {
      this.dataList = data;
      this.checkedName = data[0].name;
      data.forEach(function (item) {
        item.id = item.value;
      });
      this.examineFrom.ab_card = data[0];
    },
    // 给父级页面提供得获取本页数据得方法
    getData: function getData() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        _this.$refs['elForm'].validate(function (valid) {
          if (!valid) {
            reject({
              target: _this.tabName
            });
            return;
          }
          if (_this.examineFrom.abnormal === 1) {
            if (!_this.checkedName) {
              _this.$message.warning('请选择指定人员');
              return;
            }
            if (_this.dataList.length > 0) {
              _this.examineFrom.abnormal = _this.dataList[0].value;
            } else {
              _this.examineFrom.abnormal = _this.conf.ab_card.id;
            }
          } else {
            _this.examineFrom.ab_card = '';
          }
          _this.examineFrom.recall ? _this.examineFrom.recall = 1 : 0;
          resolve({
            ruleFrom: _this.examineFrom,
            target: _this.tabName
          });
        });
      });
    }
  }
};